'use strict';
function alwaysValid() {
  return true;
}

module.exports = {
  alwaysValid: alwaysValid,
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/html-to-react/lib/is-valid-node-definitions.js
// module id = CAtb
// module chunks = 0